<template>
	<el-container class="page-x" direction="vertical">
		<div class="search-x">
			<div class="search-item">
				<span class="label">角色名称</span>
				<el-input
					class="input-box"
					clearable
					v-model.trim="searchBox.roleName"
				></el-input>
			</div>
			<div class="search-item">
				<span class="label">状态</span>
				<el-select v-model="searchBox.roleStatus" clearable>
					<el-option
						v-for="item in roleStatusArr"
						:value="item.value"
						:key="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</div>
			<div class="search-item">
				<span class="label">归属部门</span>
				<el-select v-model="searchBox.branchId" clearable>
					<el-option
						v-for="item in branchIdList"
						:value="item.value"
						:key="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</div>
			<el-button
				v-auth="'sa_role_index'"
				type="primary"
				class="search-btn"
				@click="search"
				>查询</el-button
			>
			<el-button
				class="search-btn"
				v-auth="'sa_item_page'"
				type="primary"
				@click="() => ($root.showPage = false)"
				>重置</el-button
			>
			<el-button
				v-auth="'sa_role_save'"
				type="warning"
				class="search-btn"
				@click="toAdd(null, 1)"
				>新建角色</el-button
			>
		</div>
		<div class="table-x" ref="tableBox">
			<el-table
				v-loading="loading"
				:data="tableData"
				:height="tableHeight"
				border
				class="mb10"
			>
				<el-table-column
					prop="roleName"
					align="center"
					label="角色名称"
				>
				</el-table-column>
				<el-table-column label="状态" align="center" width="400px">
					<template slot-scope="scope">
						{{ scope.row.roleStatus ? "启用" : "禁用" }}
					</template>
				</el-table-column>
				<!-- <el-table-column
					prop="providerAbbr"
					align="center"
					label="供应商权限"
				>
				</el-table-column> -->
				<el-table-column
					prop="thirdCode"
					align="center"
					label="归属部门"
				>
					<template slot-scope="scope">
						<!-- {{ filterBranchId(scope.row.branchId) }} -->
						{{ scope.row.branchId | filterValue(branchIdList) }}
					</template>
				</el-table-column>

				<el-table-column label="操作" width="280px" align="center">
					<template slot-scope="scope">
						<el-button-group>
							<el-button
								v-auth="'sa_role_save'"
								type="text"
								size="small"
								class="table-btn"
								@click="toAdd(scope.row, 2)"
								>详情</el-button
							>
							<el-button
								v-auth="'sa_role_save'"
								type="text"
								size="small"
								class="table-btn"
								@click="toAdd(scope.row, 3)"
								>修改</el-button
							>
							<el-button
								v-auth="'sa_role_permission_allot'"
								type="text"
								size="small"
								class="table-btn"
								@click="toAuthShare(scope.row)"
								>权限分配</el-button
							>
							<el-button
								v-auth="'sa_role_shelf'"
								v-if="scope.row.roleStatus === 0"
								type="text"
								size="small"
								class="table-btn"
								@click="toUpOrDown(scope.row, 1)"
								>启用</el-button
							>
							<el-button
								v-auth="'sa_role_shelf'"
								v-if="scope.row.roleStatus === 1"
								type="text"
								size="small"
								class="table-btn"
								@click="toUpOrDown(scope.row, 0)"
								>禁用</el-button
							>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 分页部分 -->
		<div class="pagination">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page="searchBox.pageNum"
				:page-size="searchBox.pageSize"
				layout="total, prev, pager, next, jumper"
				:total="total"
				background
			>
			</el-pagination>
		</div>
		<!-- 新建角色、修改弹层 -->
		<el-dialog
			append-to-body
			:title="dialogTitle"
			:visible.sync="dialogVisible"
			class="edit-dialog"
			:close-on-click-modal="false"
		>
			<el-form
				ref="form"
				:model="formData"
				:rules="formRules"
				label-width="80px"
			>
				<el-form-item label="角色名称" prop="roleName">
					<el-input
						v-model.trim="formData.roleName"
						clearable
						:disabled="formType === 2"
					></el-input>
				</el-form-item>
				<el-form-item label="角色编码" prop="roleCode">
					<el-input
						v-model.trim="formData.roleCode"
						clearable
						:disabled="formType !== 1"
					></el-input>
				</el-form-item>
				<el-form-item label="描述">
					<el-input
						v-model.trim="formData.roleRemark"
						clearable
						:disabled="formType === 2"
					></el-input>
				</el-form-item>

				<el-form-item label="归属部门" prop="branchId">
					<el-select
						v-model="formData.branchId"
						clearable
						:disabled="formType === 2"
					>
						<el-option
							v-for="item in branchIdList"
							:value="item.value"
							:key="item.value"
							:label="item.label"
						></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="供应商" prop="providerId">
					<el-select
						v-model="formData.providerId"
						clearable
						filterable
						:disabled="formType === 2"
					>
						<el-option
							v-for="item in providerList"
							:value="item.id"
							:key="item.id"
							:label="item.label"
						></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label="状态" prop="roleStatus">
					<el-select
						v-model="formData.roleStatus"
						placeholder="请选择"
						:disabled="formType === 2"
					>
						<el-option label="禁用" :value="0"></el-option>
						<el-option label="启用" :value="1"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="分配权限">
					<el-tree
						class="mb20"
						v-loading="dialogLoading"
						ref="tree_2"
						:data="allNodes"
						node-key="id"
						:accordion="true"
						:default-expand-all="false"
						highlight-current
						show-checkbox
						:check-strictly="false"
						:props="props"
					>
					</el-tree>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button
					type="primary"
					@click="addRole"
					:loading="submitLoading"
					v-if="formType !== 2"
					>确定</el-button
				>
			</span>
		</el-dialog>
		<!-- 权限分配弹层 -->
		<el-dialog
			append-to-body
			title="权限分配"
			:visible.sync="authShareDialogVisible"
			class="edit-dialog"
			:close-on-click-modal="false"
		>
			<h2>{{ roleName }}</h2>
			<el-tree
				class="mb20"
				v-loading="dialogLoading"
				ref="tree"
				:data="allNodes"
				node-key="id"
				:accordion="true"
				:default-expand-all="false"
				highlight-current
				show-checkbox
				:check-strictly="false"
				:props="props"
			>
			</el-tree>
			<span slot="footer" class="dialog-footer">
				<el-button
					type="primary"
					@click="submit"
					:loading="submitLoading"
					>确定</el-button
				>
			</span>
		</el-dialog>
	</el-container>
</template>

<script>
	import _valid from "@/assets/js/valid.js";
	import { branchIdList } from "@/assets/js/options";
	import _ from "loadsh";
	export default {
		data() {
			function checkCode(rule, val, cb) {
				if (!val) {
					cb(new Error("请输入角色编码"));
				} else if (!_valid.checkAccount(val)) {
					cb(
						new Error(
							"角色编码格式由英文、数字及_组成的6至20位字符组成"
						)
					);
				} else {
					cb();
				}
			}
			return {
				branchIdList,

				searchBox: {
					roleName: "",
					roleStatus: "",
					pageNum: 1,
					pageSize: 20,
				},
				roleStatusArr: [
					{ label: "禁用", value: 0 },
					{ label: "启用", value: 1 },
				],
				tableHeight: 0,
				loading: false,
				tableData: [],
				total: 0,
				dialogTitle: "",
				dialogVisible: false, //新建、修改弹层
				formData: {
					roleName: "",
					roleStatus: 1,
					roleCode: "",
					roleRemark: "",
					// providerId: "",
				},
				providerList: [],
				formRules: {
					roleName: [
						{
							required: true,
							message: "请输入角色名称",
							trigger: "blur",
						},
					],
					branchId: [
						{
							required: true,
							message: "请填入归属机构",
							trigger: "blur",
						},
					],
					// providerId: [
					// 	{
					// 		required: true,
					// 		message: "请选择供应商",
					// 		trigger: "change",
					// 	},
					// ],
					roleCode: [
						{ required: true, validator: checkCode, trigger: "blur" },
					],
				},
				roleId: null, //当前角色的id
				authShareDialogVisible: false, //权限分配弹层
				dialogLoading: false,
				props: {
					label: "label",
					children: "children",
				},
				allNodes: [],
				roleName: "",
				submitLoading: false,
				formType: -1,
			};
		},
		created() {
			this.$root.breadList = [
				{ name: "系统管理", link: "" },
				{ name: "角色管理", link: "" },
			];
		},
		filters: {
			filterValue(text, data) {
				return (
					data.find((item) => {
						if (text === item.value) {
							return item;
						}
					})?.label || text
				);
			},
		},
		mounted() {
			this.$nextTick(() => {
				this.listenWindow();
				this.getData();
				this.getAllProvider();
			});
		},
		methods: {
			//窗口改变，重新取得高度
			listenWindow() {
				this.tableHeight = this.$refs.tableBox.offsetHeight;
				window.addEventListener("resize", () => {
					clearTimeout(this.resizeFlag);
					this.resizeFlag = setTimeout(() => {
						try {
							this.tableHeight = this.$refs.tableBox.offsetHeight;
						} catch (error) {}
					}, 300);
				});
			},

			search() {
				this.searchBox.pageNum = 1;
				this.getData();
			},
			getData() {
				this.loading = true;
				this.axios
					.get(this.getApiUrl("getRoleList"), {
						params: this.searchBox,
					})
					.then((res) => {
						this.loading = false;
						if (res.code === 1) {
							this.tableData = res.data.data || [];
							this.total = res.data.total;
						} else {
							this.$message.warning(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
					});
			},
			getAllProvider() {
				this.providerList = [];
				let paramsData = {
					pageNo: 1,
					pageSize: 1000,
				};
				this.axios
					.get(this.getApiUrl("providerPage"), {
						params: paramsData,
					})
					.then((res) => {
						if (res.code === 1) {
							let arr = res.data.data || [];
							arr.map((o) => {
								if (o.providerStatus === "ON") {
									this.providerList.push({
										label: o.providerName,
										id: o.id,
									});
								}
							});
						} else {
							this.$message.warning(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
					});
			},
			handleCurrentChange(val) {
				this.searchBox.pageNum = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.searchBox.pageNum = 1;
				this.searchBox.pageSize = val;
				this.getData();
			},
			toUpOrDown(item, type) {
				let text = type === 1 ? "启用" : "禁用";
				let text2 = type === 1 ? "拥有" : "失去";
				this.$confirm(
					`确定${text}该角色吗？${text}后，已分配该角色的用户将${text2}该角色及相关权限，请注意权限授予范围！`,
					`${text}角色`,
					{
						type: "warning",
					}
				)
					.then(() => {
						let param = {
							roleId: item.roleId,
							roleStatus: type,
						};
						this.axios
							.post(this.getApiUrl("roleShelf"), param)
							.then((res) => {
								this.submitLoading = false;
								if (res.code === 1) {
									this.$message.success("操作成功");
									this.getData();
								} else {
									this.$message.error(res.msg);
								}
							})
							.catch((err) => {});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: `已取消${text}操作`,
						});
					});
			},
			getAllotList(roleId) {
				this.dialogLoading = true;
				let p = {
					roleId: roleId || "", // 死值
				};
				let _this = this;
				return new Promise((resolve, reject) => {
					this.axios
						.get(this.getApiUrl("allotList"), {
							params: p,
						})
						.then((res) => {
							if (res.code === 1) {
								let allNodes = res.data.allNodes;
								let keys = res.data.checkedList;
								_this.allNodes = allNodes;
								resolve(keys);
							} else {
								reject(false);
								_this.$message.warning(res.msg);
							}
							this.dialogLoading = false;
						})
						.catch((err) => {
							this.dialogLoading = false;
						});
				});
			},
			// 新建角色
			toAdd(row, type) {
				if (this.$refs["form"]) {
					this.$refs["form"].clearValidate();
				}
				this.formType = type; // 1-新增 2-详情 3-修改
				if (row) {
					this.dialogTitle = type === 2 ? "详情" : "修改";
					this.roleId = row.roleId;
					let p = {
						roleId: this.roleId,
					};
					this.axios
						.get(this.getApiUrl("roleView"), {
							params: p,
						})
						.then((res) => {
							if (res.code === 1) {
								this.formData = res.data;
							} else {
								this.$message({
									type: "error",
									message: res.msg,
								});
							}
						})
						.catch((err) => {});
				} else {
					this.roleId = null;
					this.dialogTitle = "新建角色";
					this.formData = {
						roleName: "",
						roleStatus: 1,
						roleRemark: "",
						roleCode: "",
						// providerId: "",
					};
				}
				this.dialogVisible = true;
				this.getAllotList(this.roleId)
					.then((res) => {
						if (res && res.length > 0) {
							this.$refs.tree_2.setCheckedKeys(res, false);
						} else {
							this.$refs.tree_2.setCheckedKeys([], false);
						}
					})
					.catch((err) => {});
			},
			addRole() {
				this.$refs["form"].validate((valid) => {
					if (!valid) {
						return false;
					}
					let permissions = [];
					let checkedKeysArray = this.$refs.tree_2.getCheckedKeys();
					let halfCheckedKeysArray =
						this.$refs.tree_2.getHalfCheckedKeys();
					permissions = permissions.concat(
						checkedKeysArray,
						halfCheckedKeysArray
					);
					if (!permissions.length) {
						this.$message.warning("请至少分配一种权限");
						return false;
					}
					if (this.roleId) {
						// 修改
						let p = {
							..._.pickBy(this.formData, _.identity),
							roleStatus: this.formData.roleStatus,
							branchId: this.formData.branchId,
							roleId: this.roleId,
							permissionIds: permissions.join(","),
						};
						delete p.createTime;
						delete p.updateTime;
						this.addRoleFn("roleSave", p);
					} else {
						let p = {
							..._.pickBy(this.formData, _.identity),
							roleStatus: this.formData.roleStatus,
							branchId: this.formData.branchId,
							permissionIds: permissions.join(","),
						};
						delete p.createTime;
						delete p.updateTime;

						this.addRoleFn("roleSave", p);
					}
				});
			},
			addRoleFn(url, param) {
				this.submitLoading = true;
				this.axios
					.post(this.getApiUrl(url), param)
					.then((res) => {
						this.submitLoading = false;
						if (res.code === 1) {
							this.$message.success("操作成功");
							this.dialogVisible = false;
							this.getData();
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.submitLoading = false;
					});
			},
			// 权限分配
			toAuthShare(row) {
				this.roleId = row.roleId;
				this.roleName = row.roleName;
				this.authShareDialogVisible = true;
				this.getAllotList(row.roleId)
					.then((res) => {
						if (res) {
							this.$refs.tree.setCheckedKeys(res, false);
						}
					})
					.catch((err) => {});
			},
			submit() {
				let permissions = [];
				let checkedKeysArray = this.$refs.tree.getCheckedKeys();
				let halfCheckedKeysArray = this.$refs.tree.getHalfCheckedKeys();
				permissions = permissions.concat(
					checkedKeysArray,
					halfCheckedKeysArray
				);
				if (!permissions.length) {
					this.$message.warning("请至少分配一种权限");
					return false;
				}
				this.submitLoading = true;
				let p = {
					roleId: this.roleId,
					permissionIds: permissions.join(","),
				};
				this.axios
					.post(this.getApiUrl("permissionAllot"), p)
					.then((res) => {
						this.submitLoading = false;
						if (res.code === 1) {
							this.$message.success("分配成功");
							this.authShareDialogVisible = false;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.submitLoading = false;
					});
			},
		},
	};
</script>

<style lang="scss" scoped type="text/scss">
</style>